import React from 'react';
import {SVGProps} from '~/src/components/svg/SVGProps';

const Share = ({title, primaryClassName, secondaryClassName, tertiaryClassName, className}: SVGProps) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
        {title && <title>{title}</title>}
        <path className={primaryClassName} d="M10 24H7v-7.15A3 3 0 0 1 10 14h8V9.41l1.27 1.26 1.41-1.42L17.41 6H16v6h-6a5 5 0 0 0-5 4.85V26h7v-4h-2z" />
        <path className={secondaryClassName} d="M20.68 9.25l-1.41 1.42 5.32 5.3L18 22.58V18h-3v2h1v6h1.41l10-10.04-6.73-6.71z" />
        <path className={tertiaryClassName} d="M10 18h5v2h-5z" />
    </svg>
);

export default Share;
